import { render } from "./CrewBase.vue?vue&type=template&id=4076bc08"
import script from "./CrewBase.vue?vue&type=script&lang=js"
export * from "./CrewBase.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__